const sectionCardStepCss = `
[data-type='section-card-step'] .card-step-wrapper.section-padding-top {
  padding-block: 40px;
}

[data-type='section-card-step'] .card-step-wrapper.section-padding-bottom {
  padding-bottom: 40px;
}

[data-type='section-card-step'] .card-step-container {
  padding: 16px;
  display: flex;
  gap: 32px;
}

[data-type='section-card-step'] .card-step-container[data-position='left'] {
  flex-direction: row;
}

[data-type='section-card-step'] .card-step-container[data-position='right'] {
  flex-direction: row-reverse;
}

[data-type='section-card-step'] .card-step-container .card-step-content {
  flex: 1;
}

[data-type='section-card-step'] .card-step-container .card-step-content .card-step-description {
  margin-bottom: 24px !important;
}

[data-type='section-card-step'] .card-step-container .card-step-content .card-step-description h1,
[data-type='section-card-step'] .card-step-container .card-step-content .card-step-description h2,
[data-type='section-card-step'] .card-step-container .card-step-content .card-step-description h3 {
  font-size: 24px;
  line-height: normal;
  margin: 0 0 16px 0 !important;
}

[data-type='section-card-step'] .card-step-container .card-step-content .card-step-description p {
  font-size: 16px;
  margin-bottom: 12px !important;
}

[data-type='section-card-step'] .card-step-container .card-step-content .card-step-list {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

[data-type='section-card-step'] .card-step-container .card-step-content .card-step-list .card-step-item {
  display: flex;
  align-items: center;
  gap: 16px;
}

[data-type='section-card-step'] .card-step-container .card-step-content .card-step-list .card-step-item .card-step-item-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 96px;
  height: 96px;
  border-radius: 50%;
  border: solid 1px #bcbcbc;
  font-size: 24px;
  font-weight: bold !important;
  color: #90cf5b;
}

[data-type='section-card-step'] .card-step-container .card-step-content .card-step-list .card-step-item-text {
  flex: 1;
}

[data-type='section-card-step'] .card-step-container .card-step-content .card-step-list .card-step-item-text h1,
[data-type='section-card-step'] .card-step-container .card-step-content .card-step-list .card-step-item-text h2,
[data-type='section-card-step'] .card-step-container .card-step-content .card-step-list .card-step-item-text h3 {
  font-size: 24px;
  line-height: normal;
  margin: 0 0 16px 0 !important;
}

[data-type='section-card-step'] .card-step-container .card-step-content .card-step-list .card-step-item-text p {
  font-size: 16px;
  margin-bottom: 4px !important;
}

[data-type='section-card-step'] .card-step-container .card-step-content .card-step-list .card-step-item-text p:last-child {
  margin-bottom: 0px !important;
}

[data-type='section-card-step'] .card-step-container .card-step-image {
  flex: 1;
  height: fit-content;
  aspect-ratio: 1 / 1;
}

[data-type='section-card-step'] .card-step-container .card-step-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@container (max-width: 768px) {
  [data-type='section-card-step'] .card-step-wrapper.section-padding-top {
    padding-block: 16px;
  }

  [data-type='section-card-step'] .card-step-wrapper.section-padding-bottom {
    padding-bottom: 16px;
  }

  [data-type='section-card-step'] .card-step-container {
    padding: 8px;
  }

  [data-type='section-card-step'] .card-step-container[data-position='left'] {
    flex-direction: column;
  }

  [data-type='section-card-step'] .card-step-container[data-position='right'] {
    flex-direction: column-reverse;
  }

  [data-type='section-card-step'] .card-step-container .card-step-content .card-step-description h1,
  [data-type='section-card-step'] .card-step-container .card-step-content .card-step-description h2,
  [data-type='section-card-step'] .card-step-container .card-step-content .card-step-description h3 {
    font-size: 20px;
    line-height: 24px;
  }

  [data-type='section-card-step'] .card-step-container .card-step-content .card-step-description p {
    font-size: 14px;
  }

  [data-type='section-card-step'] .card-step-container .card-step-content .card-step-list .card-step-item .card-step-item-number {
    width: 64px;
    height: 64px;
    font-size: 20px;
  }

  [data-type='section-card-step'] .card-step-container .card-step-content .card-step-list .card-step-item-text h1,
  [data-type='section-card-step'] .card-step-container .card-step-content .card-step-list .card-step-item-text h2,
  [data-type='section-card-step'] .card-step-container .card-step-content .card-step-list .card-step-item-text h3 {
    font-size: 20px;
    line-height: 24px;
  }

  [data-type='section-card-step'] .card-step-container .card-step-content .card-step-list .card-step-item-text p {
    font-size: 14px;
  }
}
`;
export default sectionCardStepCss;
